import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import PageHeader from "@/components/PageHeader";
import Gallery from "@/components/fliers/Gallery";
import Studio from "@/components/fliers/Studio";
import TemplateManager from "@/components/fliers/TemplateManager";
import Autopilot from "@/components/fliers/Autopilot";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Images, Wand2, LayoutTemplate, Sunrise } from "lucide-react";

export default function Fliers() {
  const { hasRole } = useAuth();
  const officer = hasRole("officer");
  const [fliers, setFliers] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [tab, setTab] = useState("gallery");
  const [studioTemplate, setStudioTemplate] = useState("");
  const loadFliers = () => api.get("/fliers").then((r) => setFliers(r.data.fliers)).catch(() => {});
  const loadTemplates = () => api.get("/fliers/templates").then((r) => setTemplates(r.data.templates)).catch(() => {});
  useEffect(() => { loadFliers(); if (officer) loadTemplates(); }, [officer]);
  const openStudio = (id) => { setStudioTemplate(id); setTab("studio"); };

  return (
    <div data-testid="fliers-page">
      <PageHeader eyebrow="Celebrations" title="Birthday Fliers" description="Upload the organisation's flier once. The Studio drops each celebrant's photo into it and prints his name and birthday — then shares it on the Galleon Mess." />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="glass mb-6 flex-wrap">
          <TabsTrigger value="gallery" data-testid="fliers-tab-gallery"><Images className="mr-1.5 h-4 w-4" />Gallery</TabsTrigger>
          {officer && <TabsTrigger value="studio" data-testid="fliers-tab-compose"><Wand2 className="mr-1.5 h-4 w-4" />Studio</TabsTrigger>}
          {officer && <TabsTrigger value="templates" data-testid="fliers-tab-templates"><LayoutTemplate className="mr-1.5 h-4 w-4" />Our flier</TabsTrigger>}
          {officer && <TabsTrigger value="autopilot" data-testid="fliers-tab-autopilot"><Sunrise className="mr-1.5 h-4 w-4" />Autopilot</TabsTrigger>}
        </TabsList>
        <TabsContent value="gallery"><Gallery fliers={fliers} officer={officer} onChanged={loadFliers} /></TabsContent>
        {officer && <TabsContent value="studio"><Studio templates={templates} initialTemplate={studioTemplate} onCreated={() => { loadFliers(); setTab("gallery"); }} onNeedTemplate={() => setTab("templates")} onLayoutSaved={loadTemplates} /></TabsContent>}
        {officer && <TabsContent value="templates"><TemplateManager templates={templates} onChanged={loadTemplates} onOpenStudio={openStudio} /></TabsContent>}
        {officer && <TabsContent value="autopilot"><Autopilot templates={templates} onNeedTemplate={() => setTab("templates")} onRan={loadFliers} /></TabsContent>}
      </Tabs>
    </div>
  );
}
